export class Player {
    constructor(id, skinTone, physics, anims, offset=0) {
        this.physics = physics;
        this.anims = anims;
        this.skinTone=skinTone
        this.id = id
		this.count = 0
		this.incapacitated = false

		let player = this.physics.add.sprite(100+offset, 450, 'heldin');
		player.name = id

		player.setBounce(0.2);
		player.setCollideWorldBounds(true);

		// TODO check anims dont contain ID yet
		//if (this.anims.anims.filter(this.id+'left')) {
		//	throw new Error('gibts schon')
		//}

		//  Our player animations, turning, walking left and walking right.
		this.anims.create({
			key: this.id+'left',
			frames: this.anims.generateFrameNumbers('heldin', { start: this.skinTone+0, end: this.skinTone+3 }),
			frameRate: 10,
			repeat: -1
		});

		this.anims.create({
			key: this.id+'turn',
			frames: [ { key: 'heldin', frame: this.skinTone+4 } ],
			frameRate: 20
		});

		this.anims.create({
			key: this.id+'right',
			frames: this.anims.generateFrameNumbers('heldin', { start: this.skinTone+5, end: this.skinTone+8 }),
			frameRate: 10,
			repeat: -1
		});
        this.player = player;
        this.turn()
    }

	scoreIfNameMatches(img = {name:''}) {
		if (this.id === img.name && !this.incapacitated) {
			this.count++;
		}
	}

    hitBomb() {
		this.incapacitated=true
		this.player.setVelocityX(0)
		this.player.setVelocityY(0)
        this.player.setTint(0xff0000);
        this.turn()
    }

	hitBombIfNameMatches(img = {name:''}) {
		if (this.id === img.name) {
			this.hitBomb()
		}
    }

    turn() {
        this.player.anims.play(this.id + 'turn')
    }

    img() {
        return this.player
    }

    update(cur) {
		if (this.incapacitated) {
			return
		}
        let playr = this.player
        if (cur.left.isDown)
		{
			playr.setVelocityX(-160);

			playr.anims.play(this.id+'left', true);
		}
		else if (cur.right.isDown)
		{
			playr.setVelocityX(160);

			playr.anims.play(this.id+'right', true);
		}
		else
		{
			playr.setVelocityX(0);

			playr.anims.play(this.id+'turn');
		}

		if (cur.up.isDown && playr.body.touching.down)
		{
			playr.setVelocityY(-330);
		}
    }
}